import { render } from "./RecepcionesPagos.vue?vue&type=template&id=0436a2d0"
import script from "./RecepcionesPagos.vue?vue&type=script&lang=js"
export * from "./RecepcionesPagos.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/js/components/recepciones/RecepcionesPagos.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "0436a2d0"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('0436a2d0', __exports__)) {
    api.reload('0436a2d0', __exports__)
  }
  
  module.hot.accept("./RecepcionesPagos.vue?vue&type=template&id=0436a2d0", () => {
    api.rerender('0436a2d0', render)
  })

}


export default __exports__